import { type CustomServiceInventoryItem } from '@api/api/inventory-schema';

export const customService: CustomServiceInventoryItem[] = [
  {
    name: 'Mocking Value_Deployer',
    items: [
      {
        id: 'xxxxxx',
        name: 'How to Mock a Value',
        summary: 'This is a summary of the value',
      },
      {
        id: 'yyyyyy',
        name: 'How to Mock a Value1',
        summary:
          'This is a summary of the value. A longer summary with more details.',
      },
    ],
  },
];

const customMcpDetailsById: Record<string, string> = {
  xxxxxx: `## How to Mock a Value

This is a **mock MCP response** for tool \`xxxxxx\`.

- Return a canned payload while the backend is unavailable
- Keep the inventory list and drawer details in sync by id

\`\`\`ts
const value = mockValue();
\`\`\`
`,
  yyyyyy: `## How to Mock a Value1

Longer mock markdown for tool \`yyyyyy\`.

1. Open the drawer from the inventory item
2. Fetch details with the tool id
3. Render the response as markdown
`,
};

export const fetchCustomMcpItemDetails = async (id: string): Promise<string> =>
  customMcpDetailsById[id] ?? '';
